import { useTranslation } from 'react-i18next';
import { Tag } from 'antd';

const STATUS_COLORS = {
  DRAFT: 'default',
  CALCULATED: 'blue',
  SHADOW_COMPARED: 'orange',
  APPROVED: 'green',
  FINALIZED: 'purple',
};

const STATUS_KEYS = {
  DRAFT: 'ozStatusDraft',
  CALCULATED: 'ozStatusCalculated',
  SHADOW_COMPARED: 'ozStatusShadowCompared',
  APPROVED: 'ozStatusApproved',
  FINALIZED: 'ozStatusFinalized',
};

export default function RunStatusTag({ status }) {
  const { t } = useTranslation(['forms']);
  return (
    <Tag color={STATUS_COLORS[status] || 'default'}>
      {t(STATUS_KEYS[status]) || status}
    </Tag>
  );
}
